module.exports = __webpack_public_path__ + "assets/20803fc01854f5c2a50d91881c577ecd.logo-color.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/logo-color.png
 ** module id = 838
 ** module chunks = 1
 **/